import React from 'react'
import { TableHeader } from './TableHeader'
import { TableRow } from './TableRow'

const tableStyle = {
  height: 40
};

export const Table =(props)=> {
  /* Expected tableContents
         [header1 , header2, ... , headerN]
         [value1 , value2, ... , valueN ]*/
  const headers = props.tableContents[0];
  let rows = [];
  for (let i = 1; i < props.tableContents.length; i++){
    rows.push(
        <TableRow contents = {props.tableContents[i]} />
    );
  }
  return(
    <table style={tableStyle} className="table table-sm mx-4 my-2">
        <thead>
            <TableHeader contents = {headers} />
        </thead>
        <tbody>
            {rows}
        </tbody>
    </table>
  );
}

